import { IEnrichedTransactionModel } from "@cosine/types/api-models";

export default function getDatetimeForTransaction (transaction: IEnrichedTransactionModel): string {
  return transaction.TransactionPostedDate;
}
